import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateNotifications } from "web_myplann/Api/Notifications/notificatioKeys";
import { patchNotificationsReadAllV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useNotificationMarkAllAsReadMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((filterLastnotificationid: number) =>
			patchNotificationsReadAllV2(filterLastnotificationid),
		),
		onSettled: () => {
			invalidateNotifications(queryClient);
		},
	});
};
